module.exports = __webpack_public_path__ + "media/images/lb/332-821e9db2bef2b4e6056bfbccc669180e.svg";